module.exports = __webpack_public_path__ + "static/img/icon_lianxiwomen_location.8b6b54a2.png";